export enum FieldTypes {
  YesNo,
  TherapeuticClass,
  SpecialityType,
  DatePicker,
  ActiveInactive,
  Licensed,
  ActiveDeprecated,
  TherapeuticArea,
  HighLow,
  LockedUnlockedForm,
  VerifiedNotVerified,
  ServiceGroups = 'serviceGroups',
  RoleId = 'roleId',
  Permissions = 'permissions',
}
